export const styled = {
    myMain: {
        border: "5px solid #8e24aa",
        padding: '20px'
    },
    myIntro: {
        fontSize: '30px',
    },
    myInput: {
        width: '60%'
    },
    myBtnAdd: {
        margin: '0 5px',
        fontWeight: 'bold',
        color: 'black',
        fontSize: '20px'
    },
    myHr: {
        margin: '50px 0'
    },
    myTextCell: {
        fontSize: '20px',
        fontWeight: 'bold'
    }
}